import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';
import { DateBoundTimePicker } from 'components/TimePicker/DateBoundTimePicker';
import { coercePickerDate } from 'utils/timePickerBridge';
import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import { Box } from '@mui/system';
import { Button, Stack } from '@mui/material';
import { getBloodBarcode } from 'apis/survey';
import { useEffect } from 'react';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  blood: string;
  bloodBarcod: string;
  setBloodBarcode: (bloodBarcod: string) => void;
  setBloodBarcodeImg: (bloodBarcodImg: string) => void;

  patient_id: number;
  user_id: number;
}

const BloodInfo = (props: Props) => {
  const {
    blood,
    disabled,
    watch,
    setValue,
    bloodBarcod,
    setBloodBarcode,
    setBloodBarcodeImg,
    getValues,
    register,
    user_id,
    patient_id,
  } = props;

  const rows = [
    { title: '혈액번호', variable: 'blood_number', type: 'text' },
    { title: '혈액명', variable: 'blood_name', type: 'text' },
    { title: '혈액형', variable: 'type', type: 'label' },
    { title: '용량(mL)', variable: 'volume', type: 'text' },
    { title: '도착확인시간', variable: 'arrival_time', type: 'time' },
    {
      title: '혈액도착확인자',
      variable: 'blood_transfusion_arrival',
      type: 'text',
    },
    { title: '수혈확인자1', variable: 'transfusion_check1', type: 'text' },
    { title: '수혈확인자2', variable: 'transfusion_check2', type: 'text' },
    {
      title: '수혈시작일시',
      variable: 'transfusion_start_time',
      type: 'time',
    },
    { title: '수혈시작의료인', variable: 'practitioner_start', type: 'text' },
    { title: '수혈종료일시', variable: 'transfusion_end_time', type: 'time' },
    { title: '수혈종료의료인', variable: 'practitioner_end', type: 'text' },
  ];

  const bloodBarcodeMakeHandler = (num: number) => {
    getBloodBarcode({ blood_number: num, user_id, patient_id })
      .then(({ data }) => {
        setBloodBarcodeImg(data);
      })
      .catch(e => console.log(`${e}발생`));
  };

  useEffect(() => {
    if (bloodBarcod) bloodBarcodeMakeHandler(Number(bloodBarcod));
    return;
  }, []);

  return (
    <>
      <RowContainer xs={12} sx={{ marginTop: '-32px' }}>
        {rows.map(({ title, variable, type }) => (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            {type === 'text' &&
              (variable === 'blood_number' ? (
                <Box sx={{ display: 'flex', direction: 'row', gap: '2px' }}>
                  <MuiTextField
                    value={watch('blood_number')}
                    onChange={e => {
                      setValue('blood_number', e.target.value);
                      setBloodBarcode(e.target.value);
                    }}
                    required={false}
                    disabled={disabled}
                    sx={{ width: '65%' }}
                  />
                  <Button
                    variant="contained"
                    sx={{ width: '35%' }}
                    onClick={() => bloodBarcodeMakeHandler(Number(bloodBarcod))}
                  >
                    생성
                  </Button>
                </Box>
              ) : (
                <MuiTextField
                  value={watch(`${variable}`)}
                  onChange={e => setValue(variable, e.target.value)}
                  required={false}
                  disabled={disabled}
                />
              ))}
            {type === 'label' && (
              <Form.MuiTextField
                disabled={disabled}
                value={blood}
                InputProps={{ readOnly: true }}
              />
            )}
            {type === 'time' && (
              <DateBoundTimePicker
                disabled={disabled}
                value={coercePickerDate(watch(`${variable}`)) || null}
                onChange={value => setValue(variable, value)}
                placeholder="00:00"
                usePortal={false}
              />
            )}
          </RowContent>
        ))}
        <RowContent title="Irradiation 유무" titleRatio={1} childrenRatio={5}>
          <Stack direction="row">
            <Form.MuiRadioGroup
              i18nKey="EXIST.SHORT"
              values={[2, 1]}
              disabled={disabled}
              defaultValue={getValues('irradiation.has_irradiation')}
              onChange={v => setValue('irradiation.has_irradiation', v)}
            />
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="직접입력"
              {...register('irradiation.content')}
            />
          </Stack>
        </RowContent>
        <RowContent title="교차검사 결과" titleRatio={1} childrenRatio={5}>
          <Stack direction="row">
            <Form.MuiRadioGroup
              i18nKey="FITNESS"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('filtering.is_compatible')}
              onChange={v => setValue('filtering.is_compatible', v)}
            />
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="직접입력"
              {...register('filtering.content')}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default BloodInfo;
